import { v1 as uuidV1 } from 'uuid';

import { AD_CONNECTOR_TYPE } from '@silverfort-nodelibs/common/utils/consts';
import { SYSTEM_MODES } from '@silverfort-nodelibs/common/utils/system-mode-config';
import {
    addFieldsToArray,
    buildCertificateField,
    buildField,
    removeFromArray,
    updateTabField,
    updateTabFieldArray
} from '../../common/utils';
import { SUBCATEGORIES } from '../../common/categories';
import {
    APPLICATION_SETTINGS_FIELDS,
    AVAILABILITY_ZONE_FIELDS,
    AZURE_CONNECTORS_FIELDS,
    COMMON_FIELDS,
    COMPANY_INFO_FIELDS,
    DESKTOP_MESSAGING_SERVICES_FIELDS,
    LICENSE_FIELDS,
    NODE_FIELDS,
    OKTA_CONNECTORS_FIELDS,
    PROTECTED_DOMAIN_FIELDS
} from '../../common/fields';
import { mapFieldsToRadiusClients, mapRadiusClientsFields, newRadiusClient } from '../General/generalReducer';
import {
    initDomainField,
    initFieldsState as initProtectedDomainsFieldsState,
    mapDomainToSettingsByWizard
} from '../ProtectedDomains/protectedDomainsReducer';
import {
    fieldsReducer as nodesFieldsReducer,
    initFieldsState as initSFNodesFieldsState,
    mapDomainToSettings as mapDomainNodesToSettings,
    mapNodeToSettingsByWizard
} from '../SilverfortNodes/silverfortNodesReducer';
import {
    mapFieldsToPushServices,
    mapMessagingServicesToFields,
    newMessagingService
} from '../DesktopApplication/desktopApplicationReducer';
import {
    fieldsReducer as azFieldsReducer,
    initFieldsState as initAzFieldsState,
    mapToSettings as mapAzFieldsToSettings
} from '../AvailabilityZones/availabilityZonesReducer';
import {
    addMultipleAppsAction,
    mapADFSFields,
    mapAzureADConnectorFields,
    mapFieldsToADFS,
    mapFieldsToAzureConnectors,
    mapFieldsToOktaConnectors,
    mapFieldsToPingFed,
    mapNewAzureADConnectorFields,
    mapNewFieldsToAzureConnectors,
    mapOktaConnectorFields,
    mapPingFedFields,
    newADFSApp,
    newAzureApp,
    newAzureConnector,
    newPingFedApp
} from '../Integrations/integrationsReducer';
import * as generalActions from '../General/generalActions';
import * as licenseActions from '../Licensing/licensingActions';
import * as protectedDomainsActions from '../ProtectedDomains/protectedDomainsActions';
import * as sfNodesActions from '../SilverfortNodes/silverfortNodesActions';
import * as desktopAppActions from '../DesktopApplication/desktopApplicationActions';
import * as integrationsActions from '../Integrations/integrationsActions';
import * as availabilityZonesActions from '../AvailabilityZones/availabilityZonesActions';
import { commonActionsReducer } from '../../common/actions';
import { validateFilledForwarding, validateLdapServerUnique } from '../../common/validators';

import WelcomeIcon from '../../common/Images/WelcomeIcon.png';
import LicenseIcon from '../../common/Images/LicenseIcon.png';
import GeneralIcon from '../../common/Images/GeneralIcon.png';
import ProtectedDomainsIcon from '../../common/Images/ProtectedDomainsIcon.png';
import SilverfortNodesIcon from '../../common/Images/SilverfortNodesIcon.png';
import DesktopApplicationsIcon from '../../common/Images/DesktopApplicationsIcon.png';
import IntegrationsIcon from '../../common/Images/IntegrationsIcon.png';
import FinishIcon from '../../common/Images/FinishIcon.png';
import AvailabilityZonesIcon from '../../common/Images/AvailabilityZonesIcon.png';

import {
    AVAILABILITY_ZONES_STEP_ID,
    DESKTOP_APP_STEP_ID,
    FINISH_STEP_ID,
    GENERAL_STEP_ID,
    INTEGRATIONS_STEP_ID,
    LICENSE_STEP_ID,
    MID_FINISH_STEP_ID,
    PROTECTED_DOMAIN_STEP_ID,
    SF_NODES_STEP_ID,
    WELCOME_STEP_ID
} from './wizardIds';

const {
    RADIUS_CLIENTS,
    PROTECTED_DOMAINS,
    SILVERFORT_NODES,
    ADFS_FEDERATED_APPS,
    PING_FEDERATED_APPS,
    AVAILABILITY_ZONES
} = SUBCATEGORIES;
const { LICENSE_KEY } = LICENSE_FIELDS;
const { COMPANY_LOGO, COMPANY_SUPPORT_EMAIL, COMPANY_NAME } = COMPANY_INFO_FIELDS;
const {
    DOMAIN_ID,
    DOMAIN_NAME,
    KERBEROS_FORWARDING,
    NTLM_FORWARDING,
    LDAP_FORWARDING,
    LDAPS_FORWARDING,
    LDAP_IP,
    BACKUP_LDAP_IP
} = PROTECTED_DOMAIN_FIELDS;
const { LDAP_IP_OPTIONS } = COMMON_FIELDS;
const { NODE_ID, NODE_NAME } = NODE_FIELDS;
const {
    MESSAGING_SERVICES_ENABLED,
    SAAS_MESSAGING_SERVICES_ENABLED,
    DEFAULT_CERTIFICATE_REQUEST,
    DEFAULT_CERTIFICATE
} = APPLICATION_SETTINGS_FIELDS;
const { MESSAGING_SERVICES } = DESKTOP_MESSAGING_SERVICES_FIELDS;
const { AZURE_AD_CONNECTOR, AZURE_REDIRECT_URI, NEW_AZURE_AD_CONNECTOR } = AZURE_CONNECTORS_FIELDS;
const { OKTA_REDIRECT_URI, OKTA_BRIDGE_ENABLED, OKTA_BRIDGE_CONNECTOR } = OKTA_CONNECTORS_FIELDS;

export const STEPS = {
    [WELCOME_STEP_ID]: { NAME: 'Welcome', ICON: WelcomeIcon },
    [LICENSE_STEP_ID]: { NAME: 'License', ICON: LicenseIcon },
    [GENERAL_STEP_ID]: { NAME: 'General', ICON: GeneralIcon },
    [PROTECTED_DOMAIN_STEP_ID]: { NAME: 'Protected Domains', ICON: ProtectedDomainsIcon },
    [SF_NODES_STEP_ID]: { NAME: 'Silverfort Nodes', ICON: SilverfortNodesIcon },
    [AVAILABILITY_ZONES_STEP_ID]: { NAME: 'Availability Zones', ICON: AvailabilityZonesIcon },
    [MID_FINISH_STEP_ID]: { NAME: 'Finish', ICON: FinishIcon },
    [DESKTOP_APP_STEP_ID]: { NAME: 'Desktop Application', ICON: DesktopApplicationsIcon, OPTIONAL: true },
    [INTEGRATIONS_STEP_ID]: { NAME: 'Integrations', ICON: IntegrationsIcon, OPTIONAL: true },
    [FINISH_STEP_ID]: { NAME: 'Finish', ICON: FinishIcon }
};

const transformAzToWizardState = (state) => {
    const { shared, ...fields } = state;
    return {
        shared,
        [AVAILABILITY_ZONES.ID]: buildField(
            AVAILABILITY_ZONES,
            Object.keys(fields).map((key) => {
                return { ...fields[key], guid: key };
            })
        )
    };
};

const transformWizardStateToAzState = (state) => {
    const azState = { shared: state.shared };
    state[AVAILABILITY_ZONES.ID].value.forEach((az) => {
        azState[az.id] = az;
        delete azState[az.id].guid;
    });
    return azState;
};

const transformNodesToWizardState = (state) => {
    const { ldapIpOptions, ...fields } = state;
    return {
        ldapIpOptions,
        [SILVERFORT_NODES.ID]: buildField(
            SILVERFORT_NODES,
            Object.keys(fields).map((key) => {
                return fields[key].fields;
            })
        )
    };
};

const transformWizardStateToNodeState = (state) => {
    const nodesState = { [COMMON_FIELDS.LDAP_IP_OPTIONS.ID]: state[COMMON_FIELDS.LDAP_IP_OPTIONS.ID] };
    state[SILVERFORT_NODES.ID].value.forEach((node) => {
        const nodeId = node[NODE_FIELDS.NODE_ID.ID].value;
        nodesState[nodeId] = { fields: node };
    });
    return nodesState;
};

export const fieldsReducer = (state, action) => {
    let updatedState = state;
    switch (action.type) {
        case licenseActions.UPDATE_LICENSE:
            const { licenseDetails } = action.payload;
            updatedState = updateTabField(state, LICENSE_STEP_ID, LICENSE_KEY.ID, licenseDetails.licenseKey);
            updatedState[LICENSE_STEP_ID].fields[LICENSE_KEY.ID].licenseDetails = licenseDetails;

            if (
                licenseDetails.companyName &&
                updatedState[LICENSE_STEP_ID] &&
                updatedState[LICENSE_STEP_ID].fields[COMPANY_NAME.ID] &&
                action.payload.systemMode === SYSTEM_MODES.SAAS
            ) {
                const currentCompanyName = updatedState[LICENSE_STEP_ID].fields[COMPANY_NAME.ID].value;
                if (!currentCompanyName || currentCompanyName.toLowerCase() === 'acme') {
                    updatedState = updateTabField(
                        updatedState,
                        LICENSE_STEP_ID,
                        COMPANY_NAME.ID,
                        licenseDetails.companyName
                    );
                }
            }

            return updatedState;
        case licenseActions.UPDATE_COMPANY_NAME:
            return updateTabField(state, LICENSE_STEP_ID, action.payload.fieldId, action.payload.value);
        case generalActions.UPDATE_COMPANY_INFO:
            return updateTabField(state, GENERAL_STEP_ID, action.payload.fieldId, action.payload.value);
        case generalActions.UPDATE_RADIUS_CLIENT:
            return updateTabFieldArray(
                state,
                GENERAL_STEP_ID,
                action.payload.fieldId,
                action.payload.index,
                action.payload.arrFieldId,
                action.payload.value
            );
        case generalActions.ADD_RADIUS_CLIENT:
            return addFieldsToArray(state, GENERAL_STEP_ID, RADIUS_CLIENTS.ID, newRadiusClient());
        case generalActions.REMOVE_RADIUS_CLIENT:
            return removeFromArray(state, GENERAL_STEP_ID, RADIUS_CLIENTS.ID, action.payload);
        case protectedDomainsActions.UPDATE_DOMAIN:
            const fIndex = state[PROTECTED_DOMAIN_STEP_ID].fields[PROTECTED_DOMAINS.ID].value.findIndex((domain) => {
                return domain[DOMAIN_ID.ID].value === action.payload.domainId;
            });
            if (fIndex < 0) {
                return state;
            }
            const updatedDomainState = updateTabFieldArray(
                state,
                PROTECTED_DOMAIN_STEP_ID,
                PROTECTED_DOMAINS.ID,
                fIndex,
                action.payload.fieldId,
                action.payload.value
            );

            const updatedDomain =
                updatedDomainState[PROTECTED_DOMAIN_STEP_ID].fields[PROTECTED_DOMAINS.ID].value[fIndex];

            validateFilledForwarding(
                updatedDomain,
                KERBEROS_FORWARDING.ID,
                NTLM_FORWARDING.ID,
                LDAP_FORWARDING.ID,
                LDAPS_FORWARDING.ID
            );
            validateLdapServerUnique(updatedDomain, LDAP_IP.ID, BACKUP_LDAP_IP.ID);

            return updatedDomainState;
        case protectedDomainsActions.ADD_DOMAIN:
            const newDomainId = uuidV1();
            const newDomain = initDomainField(
                { id: newDomainId, DomainName: 'New domain', isNew: true },
                [],
                state[PROTECTED_DOMAIN_STEP_ID].fields[LDAP_IP_OPTIONS.ID].value,
                true
            );
            return addFieldsToArray(state, PROTECTED_DOMAIN_STEP_ID, PROTECTED_DOMAINS.ID, newDomain, false);
        case protectedDomainsActions.DELETE_DOMAIN:
            const deletedIndex = state[PROTECTED_DOMAIN_STEP_ID].fields[PROTECTED_DOMAINS.ID].value.findIndex(
                (domain) => {
                    return domain[DOMAIN_ID.ID].value === action.payload.domainId;
                }
            );
            if (deletedIndex < 0) {
                return state;
            }
            return removeFromArray(state, PROTECTED_DOMAIN_STEP_ID, PROTECTED_DOMAINS.ID, deletedIndex);
        case protectedDomainsActions.UPDATE_DOMAINS_FROM_FILE:
            return updateDomainsFromFile(state, action.payload.newDomains, action.payload.LdapServerOptions);
        case protectedDomainsActions.LDAP_IP_ADDED:
            const newState = { ...state };
            updatedState[SF_NODES_STEP_ID].fields[LDAP_IP_OPTIONS.ID] = {
                ...state[SF_NODES_STEP_ID].fields[LDAP_IP_OPTIONS.ID],
                value: state[SF_NODES_STEP_ID].fields[LDAP_IP_OPTIONS.ID].value.concat(action.payload.value)
            };

            newState[PROTECTED_DOMAIN_STEP_ID].fields[LDAP_IP_OPTIONS.ID] = {
                ...state[PROTECTED_DOMAIN_STEP_ID].fields[LDAP_IP_OPTIONS.ID],
                value: state[PROTECTED_DOMAIN_STEP_ID].fields[LDAP_IP_OPTIONS.ID].value.concat(action.payload.value)
            };
            return newState;
        case sfNodesActions.LDAP_IP_ADDED:
        case sfNodesActions.UPDATE_NODE:
        case sfNodesActions.DELETE_NODE:
        case sfNodesActions.DISCARD_NODE:
        case sfNodesActions.ADD_NODE_DOMAIN:
        case sfNodesActions.DELETE_NODE_DOMAIN:
            return {
                ...state,
                [SF_NODES_STEP_ID]: {
                    ...state[SF_NODES_STEP_ID],
                    fields: transformNodesToWizardState(
                        nodesFieldsReducer(transformWizardStateToNodeState(state[SF_NODES_STEP_ID].fields), action)
                    )
                }
            };
        case sfNodesActions.UPDATE_NODES_CONFIGURATION:
            const currentNodes = state[SF_NODES_STEP_ID].fields[SILVERFORT_NODES.ID].value;
            const currentNodesById = {};
            currentNodes.forEach((node) => {
                currentNodesById[node[NODE_ID.ID].value] = { fields: node, name: node[NODE_NAME.ID].value };
            });
            const newNodes = initSFNodesFieldsState(
                { settings: { NodesConfigurations: action.payload.nodesConfiguration, DomainsConfigurations: {} } },
                true
            );
            const { ldapIpOptions, ...nodeFields } = newNodes;

            const allNodesIds = new Set([...Object.keys(currentNodesById), ...Object.keys(nodeFields)]);
            const nodesFieldsValues = [];
            const sortedNodesIds = Array.from(allNodesIds).sort((firstId, secondId) => {
                const firstIdNode = currentNodesById[firstId] ? currentNodesById[firstId] : nodeFields[firstId];
                const secondIdNode = currentNodesById[secondId] ? currentNodesById[secondId] : nodeFields[secondId];
                if (firstIdNode.name > secondIdNode.name) {
                    return 1;
                }
                return -1;
            });

            sortedNodesIds.forEach((nodeId) => {
                const nodeObj = currentNodesById[nodeId] ? currentNodesById[nodeId] : nodeFields[nodeId];
                nodesFieldsValues.push(nodeObj.fields);
            });
            state[SF_NODES_STEP_ID].fields[SILVERFORT_NODES.ID].value = nodesFieldsValues;
            return state;
        case desktopAppActions.UPDATE_APPLICATION_SETTINGS:
            return updateTabField(state, DESKTOP_APP_STEP_ID, action.payload.fieldId, action.payload.value);
        case desktopAppActions.UPDATE_MESSAGING_SERVICE:
            return updateTabFieldArray(
                state,
                DESKTOP_APP_STEP_ID,
                MESSAGING_SERVICES.ID,
                action.payload.index,
                action.payload.arrFieldId,
                action.payload.value
            );
        case desktopAppActions.ADD_MESSAGING_SERVICE:
            return addFieldsToArray(state, DESKTOP_APP_STEP_ID, MESSAGING_SERVICES.ID, newMessagingService());
        case desktopAppActions.REMOVE_MESSAGING_SERVICE:
            return removeFromArray(state, DESKTOP_APP_STEP_ID, MESSAGING_SERVICES.ID, action.payload);
        case integrationsActions.UPDATE_ADFS_APP:
            return updateTabFieldArray(
                state,
                INTEGRATIONS_STEP_ID,
                ADFS_FEDERATED_APPS.ID,
                action.payload.index,
                action.payload.arrFieldId,
                action.payload.value
            );
        case integrationsActions.ADD_ADFS_APP:
            return addFieldsToArray(state, INTEGRATIONS_STEP_ID, ADFS_FEDERATED_APPS.ID, newADFSApp());
        case integrationsActions.ADD_MULTIPLE_ADFS_APPS:
            return addMultipleAppsAction(state, action, INTEGRATIONS_STEP_ID, ADFS_FEDERATED_APPS.ID, mapADFSFields);
        case integrationsActions.REMOVE_ADFS_APP:
            return removeFromArray(state, INTEGRATIONS_STEP_ID, ADFS_FEDERATED_APPS.ID, action.payload);
        case integrationsActions.UPDATE_PINGFED_APP:
            return updateTabFieldArray(
                state,
                INTEGRATIONS_STEP_ID,
                PING_FEDERATED_APPS.ID,
                action.payload.index,
                action.payload.arrFieldId,
                action.payload.value
            );
        case integrationsActions.ADD_PINGFED_APP:
            return addFieldsToArray(state, INTEGRATIONS_STEP_ID, PING_FEDERATED_APPS.ID, newPingFedApp());
        case integrationsActions.ADD_MULTIPLE_PINGFED_APPS:
            return addMultipleAppsAction(state, action, INTEGRATIONS_STEP_ID, PING_FEDERATED_APPS.ID, mapPingFedFields);
        case integrationsActions.REMOVE_PINGFED_APP:
            return removeFromArray(state, INTEGRATIONS_STEP_ID, PING_FEDERATED_APPS.ID, action.payload);
        case integrationsActions.ADD_AZURE_CONNECTOR:
            return addFieldsToArray(state, INTEGRATIONS_STEP_ID, AZURE_AD_CONNECTOR.ID, newAzureApp());
        case integrationsActions.REMOVE_AZURE_CONNECTOR:
            return removeFromArray(state, INTEGRATIONS_STEP_ID, AZURE_AD_CONNECTOR.ID, action.payload);
        case integrationsActions.ADD_NEW_AZURE_CONNECTOR:
            return addFieldsToArray(state, INTEGRATIONS_STEP_ID, NEW_AZURE_AD_CONNECTOR.ID, newAzureConnector());
        case integrationsActions.REMOVE_NEW_AZURE_CONNECTOR:
            return removeFromArray(state, INTEGRATIONS_STEP_ID, NEW_AZURE_AD_CONNECTOR.ID, action.payload);
        case integrationsActions.UPDATE_CONNECTOR:
            return updateTabFieldArray(
                state,
                INTEGRATIONS_STEP_ID,
                action.payload.fieldId,
                action.payload.index,
                action.payload.arrFieldId,
                action.payload.value
            );
        case integrationsActions.UPDATE_CONNECTORS_FIELDS:
            return updateTabField(state, INTEGRATIONS_STEP_ID, action.payload.fieldId, action.payload.value);
        case availabilityZonesActions.ADD_AZ:
        case availabilityZonesActions.UPDATE_ENTITIES:
        case availabilityZonesActions.CHANGE_AZ_DOMAIN:
        case availabilityZonesActions.DELETE_AZ:
        case availabilityZonesActions.RENAME_AZ:
        case availabilityZonesActions.MOVE_ENTITIES_TO_AZ:
        case availabilityZonesActions.UPDATE_CONFIG:
            return {
                ...state,
                [AVAILABILITY_ZONES_STEP_ID]: {
                    ...state[AVAILABILITY_ZONES_STEP_ID],
                    fields: transformAzToWizardState(
                        azFieldsReducer(transformWizardStateToAzState(state[AVAILABILITY_ZONES_STEP_ID].fields), action)
                    )
                }
            };
        default:
            return commonActionsReducer(state, action, initFieldsState);
    }
};

const updateDomainsFromFile = (fields, newDomains, LdapServerOptions) => {
    let newFields = { ...fields };
    for (const newDomainData of newDomains) {
        newDomainData.LdapDomainName = newDomainData.DomainName;
        const newDomainId = uuidV1();

        const newDomain = initDomainField(
            { id: newDomainId, ...newDomainData },
            [],
            newFields[PROTECTED_DOMAIN_STEP_ID].fields[LDAP_IP_OPTIONS.ID].value.concat(LdapServerOptions),
            true
        );
        newFields = addFieldsToArray(newFields, PROTECTED_DOMAIN_STEP_ID, PROTECTED_DOMAINS.ID, newDomain, false);
    }
    newFields[PROTECTED_DOMAIN_STEP_ID].fields[LDAP_IP_OPTIONS.ID] = buildField(
        LDAP_IP_OPTIONS,
        newFields[PROTECTED_DOMAIN_STEP_ID].fields[LDAP_IP_OPTIONS.ID].value.concat(LdapServerOptions)
    );

    return newFields;
};

export const initFieldsState = ({ settings }) => {
    const domainsFields = initProtectedDomainsFieldsState({ settings }, true);
    const { ldapIpOptions, backupLdapIpOptions, ...domainFields } = domainsFields;

    const domainsFieldsValues = [];
    const sortedDomainIds = Object.keys(domainFields).sort((firstId, secondId) => {
        if (domainFields[firstId].name > domainFields[secondId].name) {
            return 1;
        }
        return -1;
    });

    sortedDomainIds.forEach((domainId) => {
        domainsFieldsValues.push(domainFields[domainId].fields);
    });

    const nodesFields = initSFNodesFieldsState({ settings }, true);
    delete nodesFields[LDAP_IP_OPTIONS.ID];
    const nodesFieldsValues = [];
    const sortedNodesIds = Object.keys(nodesFields).sort((firstId, secondId) => {
        if (nodesFields[firstId].name > nodesFields[secondId].name) {
            return 1;
        }
        return -1;
    });

    sortedNodesIds.forEach((nodeId) => {
        nodesFieldsValues.push(nodesFields[nodeId].fields);
    });

    const azState = transformAzToWizardState(initAzFieldsState({ settings }));
    const sortedAzs = azState[AVAILABILITY_ZONES.ID].value.sort((a, b) => {
        const nameA = a.fields[AVAILABILITY_ZONE_FIELDS.NAME.ID].value
            ? a.fields[AVAILABILITY_ZONE_FIELDS.NAME.ID].value
            : '';
        const nameB = b.fields[AVAILABILITY_ZONE_FIELDS.NAME.ID].value
            ? b.fields[AVAILABILITY_ZONE_FIELDS.NAME.ID].value
            : '';
        return nameA > nameB ? 1 : -1;
    });
    azState[AVAILABILITY_ZONES.ID].value = sortedAzs;

    const systemMode = settings.systemMode || SYSTEM_MODES.ON_PREM;
    const isCompanyNameRequired = systemMode === SYSTEM_MODES.ON_PREM;

    const state = {
        [LICENSE_STEP_ID]: {
            id: LICENSE_STEP_ID,
            name: STEPS[LICENSE_STEP_ID].NAME,
            fields: {
                [COMPANY_NAME.ID]: buildField(COMPANY_NAME, settings.CompanyName, { required: isCompanyNameRequired }),
                [LICENSE_KEY.ID]: {
                    ...buildField(LICENSE_KEY, settings.License.licenseKey),
                    licenseDetails: settings.License
                }
            },
            validators: {}
        },
        [GENERAL_STEP_ID]: {
            id: GENERAL_STEP_ID,
            name: STEPS[GENERAL_STEP_ID].NAME,
            fields: {
                [COMPANY_NAME.ID]: buildField(COMPANY_NAME, settings.CompanyName, { required: isCompanyNameRequired }),
                [COMPANY_LOGO.ID]: buildField(COMPANY_LOGO, settings.CompanyLogo),
                [COMPANY_SUPPORT_EMAIL.ID]: buildField(COMPANY_SUPPORT_EMAIL, settings.CompanySupportEmail, {
                    email: true
                }),
                [RADIUS_CLIENTS.ID]: buildField(RADIUS_CLIENTS, mapRadiusClientsFields(settings.RADIUSClients))
            },
            validators: {}
        },
        [PROTECTED_DOMAIN_STEP_ID]: {
            id: PROTECTED_DOMAIN_STEP_ID,
            name: STEPS[PROTECTED_DOMAIN_STEP_ID].NAME,
            fields: {
                [PROTECTED_DOMAINS.ID]: buildField(PROTECTED_DOMAINS, domainsFieldsValues),
                [LDAP_IP_OPTIONS.ID]: buildField(LDAP_IP_OPTIONS, ldapIpOptions.value)
            },
            validators: {
                filledForwarding: [KERBEROS_FORWARDING.ID, NTLM_FORWARDING.ID, LDAP_FORWARDING.ID, LDAPS_FORWARDING.ID],
                ldapServerUnique: [LDAP_IP.ID, BACKUP_LDAP_IP.ID],
                uniqueName: {
                    fieldId: DOMAIN_NAME.ID,
                    caseSensitive: true,
                    subcategoryId: SUBCATEGORIES.PROTECTED_DOMAINS.ID
                }
            }
        },
        [SF_NODES_STEP_ID]: {
            id: SF_NODES_STEP_ID,
            name: STEPS[SF_NODES_STEP_ID].NAME,
            fields: {
                [SILVERFORT_NODES.ID]: buildField(SILVERFORT_NODES, nodesFieldsValues),
                [LDAP_IP_OPTIONS.ID]: buildField(LDAP_IP_OPTIONS, ldapIpOptions.value)
            },
            validators: {}
        },
        [AVAILABILITY_ZONES_STEP_ID]: {
            id: AVAILABILITY_ZONES_STEP_ID,
            name: STEPS[AVAILABILITY_ZONES_STEP_ID].NAME,
            fields: azState
        },
        [DESKTOP_APP_STEP_ID]: {
            id: DESKTOP_APP_STEP_ID,
            name: STEPS[DESKTOP_APP_STEP_ID].NAME,
            fields: {
                [MESSAGING_SERVICES_ENABLED.ID]: buildField(MESSAGING_SERVICES_ENABLED, settings.PushServicesEnabled),
                [SAAS_MESSAGING_SERVICES_ENABLED.ID]: buildField(
                    SAAS_MESSAGING_SERVICES_ENABLED,
                    settings.SaasPushServicesEnabled
                ),
                [DEFAULT_CERTIFICATE_REQUEST.ID]: buildField(DEFAULT_CERTIFICATE_REQUEST, {
                    data: settings.PushServicesCertificateRequest,
                    fqdn: '',
                    san: ''
                }),
                [DEFAULT_CERTIFICATE.ID]: buildCertificateField(
                    DEFAULT_CERTIFICATE,
                    settings.PushServicesCertificateData
                ),
                [MESSAGING_SERVICES.ID]: buildField(
                    MESSAGING_SERVICES,
                    mapMessagingServicesToFields(settings.PushServicesNodesConfigurations)
                )
            },
            validators: {}
        }
    };

    if (!settings.AADApplications) {
        state[INTEGRATIONS_STEP_ID] = {
            id: INTEGRATIONS_STEP_ID,
            name: STEPS[INTEGRATIONS_STEP_ID].NAME,
            fields: {
                [ADFS_FEDERATED_APPS.ID]: buildField(ADFS_FEDERATED_APPS, mapADFSFields(settings.RelyingParties)),
                [PING_FEDERATED_APPS.ID]: buildField(
                    PING_FEDERATED_APPS,
                    mapPingFedFields(settings.RelyingPartiesPingFed)
                ),
                [NEW_AZURE_AD_CONNECTOR.ID]: buildField(
                    NEW_AZURE_AD_CONNECTOR,
                    mapNewAzureADConnectorFields(settings.AADConnectors)
                ),
                [OKTA_REDIRECT_URI.ID]: buildField(OKTA_REDIRECT_URI, settings.OktaRedirectURI),
                [OKTA_BRIDGE_ENABLED.ID]: buildField(OKTA_BRIDGE_ENABLED, settings.OktaBridgeEnabled),
                [OKTA_BRIDGE_CONNECTOR.ID]: buildField(
                    OKTA_BRIDGE_CONNECTOR,
                    mapOktaConnectorFields(settings.OktaApplications, true)
                )
            },
            validators: {}
        };
    } else {
        state[INTEGRATIONS_STEP_ID] = {
            id: INTEGRATIONS_STEP_ID,
            name: STEPS[INTEGRATIONS_STEP_ID].NAME,
            fields: {
                [ADFS_FEDERATED_APPS.ID]: buildField(ADFS_FEDERATED_APPS, mapADFSFields(settings.RelyingParties)),
                [PING_FEDERATED_APPS.ID]: buildField(
                    PING_FEDERATED_APPS,
                    mapPingFedFields(settings.RelyingPartiesPingFed)
                ),
                [AZURE_AD_CONNECTOR.ID]: buildField(
                    AZURE_AD_CONNECTOR,
                    mapAzureADConnectorFields(settings.AADApplications, AD_CONNECTOR_TYPE.APPLICATION, true)
                ),
                [AZURE_REDIRECT_URI.ID]: buildField(AZURE_REDIRECT_URI, settings.AADApplicationsRedirectURI),
                [OKTA_REDIRECT_URI.ID]: buildField(OKTA_REDIRECT_URI, settings.OktaRedirectURI),
                [OKTA_BRIDGE_ENABLED.ID]: buildField(OKTA_BRIDGE_ENABLED, settings.OktaBridgeEnabled),
                [OKTA_BRIDGE_CONNECTOR.ID]: buildField(
                    OKTA_BRIDGE_CONNECTOR,
                    mapOktaConnectorFields(settings.OktaApplications, true)
                )
            },
            validators: {}
        };
    }

    return state;
};

export const mapToSettings = (saveAll, selectedTab, fields, currentSettings, firstTimeOnSettings) => {
    const newSettings = {};

    const licenseFields = fields[LICENSE_STEP_ID].fields;
    newSettings.License = licenseFields[LICENSE_KEY.ID].licenseDetails;

    const generalFields = fields[GENERAL_STEP_ID].fields;
    newSettings.CompanyName = generalFields[COMPANY_NAME.ID].value;
    newSettings.CompanyLogo = generalFields[COMPANY_LOGO.ID].value;
    newSettings.CompanySupportEmail = generalFields[COMPANY_SUPPORT_EMAIL.ID].value;
    newSettings.RADIUSClients = mapFieldsToRadiusClients(generalFields[RADIUS_CLIENTS.ID].value);

    const protectedDomainFields = fields[PROTECTED_DOMAIN_STEP_ID].fields;
    newSettings.DomainsConfigurations = {};
    for (const domainFields of protectedDomainFields[PROTECTED_DOMAINS.ID].value) {
        const domainId = domainFields[DOMAIN_ID.ID].value;
        const newDomainObj = mapDomainToSettingsByWizard(
            { ...currentSettings.DomainsConfigurations[domainId] } || {},
            domainFields
        );
        newSettings.DomainsConfigurations[domainId] = newDomainObj;
    }

    const nodesFields = fields[SF_NODES_STEP_ID].fields;
    newSettings.NodesConfigurations = {};
    for (const node of nodesFields[SILVERFORT_NODES.ID].value) {
        const nodeId = node[NODE_ID.ID].value;
        const newNodeObj = mapNodeToSettingsByWizard(node, currentSettings.DomainsConfigurations);
        newSettings.NodesConfigurations[nodeId] = newNodeObj;

        const newDomainsConfigurations = mapDomainNodesToSettings(
            nodeId,
            newSettings.DomainsConfigurations,
            node,
            currentSettings.NodesConfigurations[nodeId].domainsConfiguration
        );
        newSettings.DomainsConfigurations = newDomainsConfigurations;
    }

    newSettings.LdapServerOptions = protectedDomainFields[LDAP_IP_OPTIONS.ID].value;

    const desktopAppFields = fields[DESKTOP_APP_STEP_ID].fields;
    newSettings.PushServicesEnabled = desktopAppFields[MESSAGING_SERVICES_ENABLED.ID].value;
    newSettings.SaasPushServicesEnabled = desktopAppFields[SAAS_MESSAGING_SERVICES_ENABLED.ID].value;
    newSettings.PushServicesCertificateRequest = desktopAppFields[DEFAULT_CERTIFICATE_REQUEST.ID].value.data;
    newSettings.PushServicesCertificateData = desktopAppFields[DEFAULT_CERTIFICATE.ID].value;
    newSettings.PushServicesNodesConfigurations = mapFieldsToPushServices(
        desktopAppFields[MESSAGING_SERVICES.ID].value,
        currentSettings
    );

    const integrationsFields = fields[INTEGRATIONS_STEP_ID].fields;
    if (integrationsFields[NEW_AZURE_AD_CONNECTOR.ID]) {
        const azureConnectorFields = integrationsFields[NEW_AZURE_AD_CONNECTOR.ID];
        newSettings.AADConnectors = mapNewFieldsToAzureConnectors(azureConnectorFields.value);
    } else {
        newSettings.AADApplications = mapFieldsToAzureConnectors(integrationsFields);
        newSettings.AADApplicationsRedirectURI = integrationsFields[AZURE_REDIRECT_URI.ID].value;
    }
    newSettings.RelyingParties = mapFieldsToADFS(integrationsFields[ADFS_FEDERATED_APPS.ID].value);
    newSettings.RelyingPartiesPingFed = mapFieldsToPingFed(integrationsFields[PING_FEDERATED_APPS.ID].value);
    newSettings.OktaApplications = mapFieldsToOktaConnectors(integrationsFields);
    newSettings.OktaRedirectURI = integrationsFields[OKTA_REDIRECT_URI.ID].value;
    newSettings.OktaBridgeEnabled = integrationsFields[OKTA_BRIDGE_ENABLED.ID].value;
    const azConfigData = mapAzFieldsToSettings(
        true,
        null,
        transformWizardStateToAzState(fields[AVAILABILITY_ZONES_STEP_ID].fields),
        currentSettings
    );
    newSettings.azConfig = azConfigData.azConfig;
    newSettings.AzConfigExtraData = azConfigData.AzConfigExtraData;

    return newSettings;
};
